import React from 'react'
import { Table } from 'react-bootstrap'
import * as s from './EnterPicksGameMatchupTable.scss'

const EnterPicksGameMatchupTable = ({ matchUp, homeFavorite = true, favoriteName = 'Favorite', underdogName = 'Underdog' }) => {

    if (!matchUp) return null
    return (
        <div className={s.scroll} tabIndex={0} role='region' aria-label='Team statistics comparison'>
            <Table size='sm' className={s.table}>
                <thead>
                    <tr><th colSpan={2} scope='colgroup'>{favoriteName}</th><th scope='col'>Statistic</th><th colSpan={2} scope='colgroup'>{underdogName}</th></tr>
                    <tr>
                        <th scope='col'>Overall</th>
                        <th scope='col'>{homeFavorite ? "Home" : "Away"}</th>
                        <th scope='col'>Season</th>
                        <th scope='col'>{homeFavorite ? "Away" : "Home"}</th>
                        <th scope='col'>Overall</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{matchUp.favoriteRecord}</td>
                        <td>{matchUp.favoriteRecordAH}</td>
                        <th scope='row'>Record</th>
                        <td>{matchUp.underdogRecordAH}</td>
                        <td>{matchUp.underdogRecord}</td>
                    </tr>
                    <tr>
                        <td>{matchUp.favoriteSpreadRecord}</td>
                        <td>{matchUp.favoriteSpreadRecordAH}</td>
                        <th scope='row'>vs. Spread</th>
                        <td>{matchUp.underdogSpreadRecordAH}</td>
                        <td>{matchUp.underdogSpreadRecord}</td>
                    </tr>
                    <tr>
                        <td>{typeof matchUp.favoritePF === 'number' ? matchUp.favoritePF.toFixed(1) : '—'}</td>
                        <td>{typeof matchUp.favoritePFAH === 'number' ? matchUp.favoritePFAH.toFixed(1) : '—'}</td>
                        <th scope='row'>Offense</th>
                        <td>{typeof matchUp.underdogPFAH === 'number' ? matchUp.underdogPFAH.toFixed(1) : '—'}</td>
                        <td>{typeof matchUp.underdogPF === 'number' ? matchUp.underdogPF.toFixed(1) : '—'}</td>
                    </tr>
                    <tr>
                        <td>{typeof matchUp.favoritePA === 'number' ? matchUp.favoritePA.toFixed(1) : '—'}</td>
                        <td>{typeof matchUp.favoritePAAH === 'number' ? matchUp.favoritePAAH.toFixed(1) : '—'}</td>
                        <th scope='row'>Defense</th>
                        <td>{typeof matchUp.underdogPAAH === 'number' ? matchUp.underdogPAAH.toFixed(1) : '—'}</td>
                        <td>{typeof matchUp.underdogPA === 'number' ? matchUp.underdogPA.toFixed(1) : '—'}</td>
                    </tr>
                    <tr>
                        <td>{matchUp.favoriteSOS}</td>
                        <td></td>
                        <th scope='row'>Schedule strength</th>
                        <td></td>
                        <td>{matchUp.underdogSOS}</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    )
}
    
export default EnterPicksGameMatchupTable